var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.551,
    height: 24.011,
    viewBox: "0 0 19.551 24.011",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3750",
    "data-name": "Group 3750",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6580",
    "data-name": "Path 6580",
    d: "M1563.1-3268.6v-.117a2.109,2.109,0,0,1,.239-.845,2.57,2.57,0,0,1,1.485-1.246c.142-.047.292-.032.435-.068h11.594a1.964,1.964,0,0,0,.265.029,2.308,2.308,0,0,1,1.277.644c.523.493,1.028,1,1.543,1.506.434.422.854.858,1.3,1.273.273.257.54.521.8.788a2.3,2.3,0,0,1,.55.876c.05.146.03.3.065.448v.07a.962.962,0,0,0-.012.234q0,7.8,0,15.6a.325.325,0,0,0,.011.15v.117a4.893,4.893,0,0,1-.068.519,2.536,2.536,0,0,1-1.643,1.692,3.291,3.291,0,0,1-.425.066h-15.3a2.57,2.57,0,0,1-.557-.118,2.533,2.533,0,0,1-1.5-1.639c-.042-.131-.021-.271-.057-.4v-19.434A.185.185,0,0,0,1563.1-3268.6Z",
    transform: "translate(-1563.104 3270.874)",
    fill: "#AA0A00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6581",
    "data-name": "Path 6581",
    d: "M2658.243-2927.808c-.04-.029-.023-.072-.023-.108q0-7.785,0-15.57c0-.031,0-.062,0-.094.006-.012.012-.013.02,0Z",
    transform: "translate(-2638.692 2949.424)",
    fill: "#7f110b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6582",
    "data-name": "Path 6582",
    d: "M2658.265-2954.707h-.02c.005-.071-.027-.145.02-.212Z",
    transform: "translate(-2638.715 2960.551)",
    fill: "#92130d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6583",
    "data-name": "Path 6583",
    d: "M1563.1-3143.175a.11.11,0,0,1,0,.141Z",
    transform: "translate(-1563.104 3145.452)",
    fill: "#d71c13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6584",
    "data-name": "Path 6584",
    d: "M1608.906-3213.944q0-4.735,0-9.47a1.64,1.64,0,0,1,.729-1.43,1.55,1.55,0,0,1,.88-.28c.2,0,.4,0,.6,0q5.163,0,10.326,0a1.961,1.961,0,0,1,1.494.611c.216.226.446.439.67.658q1.366,1.339,2.732,2.677a1.52,1.52,0,0,1,.483,1.15q-.008,7.78,0,15.561a1.641,1.641,0,0,1-.939,1.568,1.733,1.733,0,0,1-.807.167h-11.629c-.943,0-1.885,0-2.828,0a1.627,1.627,0,0,1-1.542-.94,1.562,1.562,0,0,1-.163-.725c0-.415,0-.83,0-1.244Z",
    transform: "translate(-1608.089 3225.943)",
    fill: "#AA0A00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6585",
    "data-name": "Path 6585",
    d: "M1831.1-3010.162a7.252,7.252,0,0,1-.292,1.787c-.053.2-.1.409-.161.611a.192.192,0,0,0,.024.164,12.524,12.524,0,0,0,1.189,1.654,1.051,1.051,0,0,1,.131.165c.091.178.227.187.406.16a9.042,9.042,0,0,1,1.938-.135,2.545,2.545,0,0,1,.9.19.83.83,0,0,1,.561.729.578.578,0,0,1-.33.585,1.532,1.532,0,0,1-.854.149,4.014,4.014,0,0,1-2.22-.908,1.056,1.056,0,0,1-.177-.152.328.328,0,0,0-.371-.1,18.938,18.938,0,0,0-2.4.658.335.335,0,0,0-.179.137,17.843,17.843,0,0,1-1.063,1.544,5.156,5.156,0,0,1-.8.81,1.825,1.825,0,0,1-.917.384.939.939,0,0,1-.417-.041.632.632,0,0,1-.382-.9,1.96,1.96,0,0,1,.608-.672,9.459,9.459,0,0,1,1.62-.935c.186-.092.37-.186.556-.275a.219.219,0,0,0,.11-.114q.775-1.655,1.409-3.368a.227.227,0,0,0,0-.167,7.377,7.377,0,0,1-.4-1.368,4.1,4.1,0,0,1-.041-1.469.663.663,0,0,1,1.084-.415,1.165,1.165,0,0,1,.448.844A2.579,2.579,0,0,1,1831.1-3010.162Z",
    transform: "translate(-1820.938 3016.224)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6586",
    "data-name": "Path 6586",
    d: "M2043.344-2321.3c0-.575,0-1.149,0-1.724,0-.087.019-.113.108-.109.344.013.688-.02,1.031.021a1.364,1.364,0,0,1,1.288,1.106,2.494,2.494,0,0,1-.107,1.675,1.336,1.336,0,0,1-1.218.865c-.34.022-.68.006-1.02.016-.086,0-.082-.043-.082-.1Q2043.345-2320.43,2043.344-2321.3Z",
    transform: "translate(-2034.78 2340.034)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6587",
    "data-name": "Path 6587",
    d: "M1890.175-2321.285c0-.575,0-1.15,0-1.724,0-.081.019-.106.1-.1.387.012.774-.018,1.16.02a1.045,1.045,0,0,1,.995,1.269.983.983,0,0,1-1.022.94c-.172.01-.344.013-.516.01-.087,0-.114.021-.112.111,0,.4,0,.805,0,1.208,0,.094-.02.132-.121.125a3.049,3.049,0,0,0-.387,0c-.086,0-.1-.028-.1-.107C1890.177-2320.121,1890.175-2320.7,1890.175-2321.285Z",
    transform: "translate(-1884.342 2340.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6588",
    "data-name": "Path 6588",
    d: "M2217.252-2321.331c0-.575,0-1.15,0-1.724,0-.086.014-.119.111-.118.61.005,1.22,0,1.83,0,.078,0,.114.013.1.1-.014.126.054.3-.027.37s-.237.02-.362.021c-.317,0-.634,0-.95,0-.075,0-.1.018-.1.1q.007.457,0,.915c0,.074.023.092.094.091.317,0,.633,0,.95,0,.09,0,.117.025.109.112a1.338,1.338,0,0,0,0,.258c.011.1-.031.121-.125.119-.3-.006-.6,0-.9-.005-.11,0-.126.033-.125.131,0,.453,0,.907,0,1.361,0,.1-.029.126-.125.12a3.2,3.2,0,0,0-.387,0c-.085.005-.1-.025-.1-.105C2217.253-2320.174,2217.252-2320.752,2217.252-2321.331Z",
    transform: "translate(-2205.588 2340.069)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6589",
    "data-name": "Path 6589",
    d: "M2045.133-2775.128a14.829,14.829,0,0,0,1.408,1.857,15.5,15.5,0,0,0-2.375.617C2044.517-2773.472,2044.858-2774.276,2045.133-2775.128Z",
    transform: "translate(-2035.59 2783.966)",
    fill: "#AA0A00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6590",
    "data-name": "Path 6590",
    d: "M2204.27-2670.039a8.79,8.79,0,0,1,1.876-.124,1.4,1.4,0,0,1,.539.144.492.492,0,0,1,.28.541.509.509,0,0,1-.468.378,1.372,1.372,0,0,1-.551-.087,5.59,5.59,0,0,1-1.585-.764C2204.331-2669.973,2204.29-2669.983,2204.27-2670.039Z",
    transform: "translate(-2192.839 2680.888)",
    fill: "#AA0A00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6591",
    "data-name": "Path 6591",
    d: "M1840.781-2592.707a9.732,9.732,0,0,1-.734,1.059,7.474,7.474,0,0,1-.5.572,1.7,1.7,0,0,1-.658.434.349.349,0,0,1-.364-.047.348.348,0,0,1-.1-.442,1.3,1.3,0,0,1,.377-.456,6.028,6.028,0,0,1,1.186-.747q.343-.176.689-.347C1840.705-2592.7,1840.734-2592.722,1840.781-2592.707Z",
    transform: "translate(-1833.477 2604.802)",
    fill: "#AA0A00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6592",
    "data-name": "Path 6592",
    d: "M2057.346-2991.853a7.333,7.333,0,0,1-.3-1.062,3.908,3.908,0,0,1-.084-1.164.958.958,0,0,1,.116-.365.308.308,0,0,1,.322-.187.367.367,0,0,1,.309.254,1.553,1.553,0,0,1,.04.639A9.476,9.476,0,0,1,2057.346-2991.853Z",
    transform: "translate(-2048.14 2999.561)",
    fill: "#AA0A00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6593",
    "data-name": "Path 6593",
    d: "M2077.423-2294.483c0-.4.006-.8,0-1.207,0-.128.038-.16.155-.147.1.011.2,0,.292.015a.825.825,0,0,1,.708.6,2.278,2.278,0,0,1,0,1.45.845.845,0,0,1-.878.636c-.272.007-.272.007-.272-.258Z",
    transform: "translate(-2068.25 2313.224)",
    fill: "#AA0A00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6594",
    "data-name": "Path 6594",
    d: "M1924.61-2296.9c.09.006.179.015.269.018a.486.486,0,0,1,.441.417,1.02,1.02,0,0,1,0,.443.47.47,0,0,1-.439.391,3.505,3.505,0,0,1-.48.021c-.056,0-.075-.02-.075-.075q0-.569,0-1.138c0-.056.017-.077.074-.073s.141,0,.211,0Z",
    transform: "translate(-1917.885 2314.264)",
    fill: "#AA0A00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/PdfIcon.2fc220a2a209f198b2ac59276be748d9.svg";
export { ForwardRef as ReactComponent };